import React, { Component } from "react";
import PropTypes from 'prop-types';

class AladinLiteReactComponent extends Component {
    constructor(props) {
        super(props);
        this.scriptLoaded = this.scriptLoaded.bind(this);
        this.handleStarClick = this.handleStarClick.bind(this);
        this.handleFieldClick = this.handleFieldClick.bind(this);
        this.handleDoubleClick = this.handleDoubleClick.bind(this);
        this.state = {
            aladinInstance: null,
            catalog: null,
            selectedStar: null
        };
    }

    componentDidMount() {
        console.log('componentDidMount');
        const aladinStyle = document.createElement('link');
        aladinStyle.href = "https://aladin.u-strasbg.fr/AladinLite/api/v2/latest/aladin.min.css";
        aladinStyle.rel = 'stylesheet';
        aladinStyle.type = 'text/css';
        document.head.appendChild(aladinStyle);

        // Загрузка jQuery
        const jqScript = document.createElement("script");
        jqScript.src = "https://code.jquery.com/jquery-1.12.1.min.js";
        // jqScript.src = "https://code.jquery.com/jquery-1.9.1.min.js";
        jqScript.async = true;
        document.body.appendChild(jqScript);

        // Загрузка скрипта Aladin Lite
        const script = document.createElement("script");
        // script.src = "https://aladin.cds.unistra.fr/AladinLite/api/v3/latest/aladin.js";
        script.src = "https://aladin.u-strasbg.fr/AladinLite/api/v2/latest/aladin.min.js";
        script.async = true;
        script.onload = this.scriptLoaded;
        document.body.appendChild(script);
    }
    
    componentDidUpdate(prevProps) {
        console.log('componentDidUpdate');
        console.log('this.state=', this.state);
        if (this.state.aladinInstance) {
            console.log('this.state.aladinInstance');
            if (prevProps.target !== this.props.target) {
                console.log('update target', this.props.target);
                this.state.aladinInstance.gotoObject(this.props.target);
            }
            if (prevProps.fov !== this.props.fov) {
                console.log('update fov', this.props.fov);
                this.state.aladinInstance.setFoV(this.props.fov);
            }
            if (prevProps.stars !== this.props.stars) {
                console.log('update stars', this.props.stars)
                this.updateCatalog();
            }

            if (prevProps.selectedStar !== this.props.selectedStar) {
                console.log('update selected star', this.props.selectedStar)
                this.updateSelectedStar();
            }            
        }
    }

    scriptLoaded() {
        const {target, fov, stars} = this.props;
        console.log('scriptLoaded, stars=', stars);
        const win = window;
        const params = { 
            survey: 'P/DSS2/color', 
            projection: "AIT",
            showReticle: true,
            // reticleColor:"rgb(10, 10, 10)", 
            fov: fov,
            target: target, 
        };
        let aladin = A.aladin('#aladin-lite-div', params);
        var cat = A.catalog({
                        name: 'Stars',
                        sourceSize: 12,
                        color: 'red',
                        shape: 'square',
                        // onClick: 'showPopup',
                  });

        stars.forEach(star => {
              cat.addSources([A.source(star.ra, star.dec, {name: star.name})]);
        });
        
        aladin.addCatalog(cat);        
        cat.onClick = this.handleStarClick;
        aladin.on('click', this.handleFieldClick);
        aladin.on('dblclick', this.handleFieldDoubleClick);
        
        this.setState({ catalog: cat });
        this.setState({ aladinInstance: aladin });
    }
    
    updateCatalog() {
        console.log('updateCatalog')
        const { stars } = this.props;
        console.log('stars=', stars)
    }
    
    updateSelectedStar() {
        console.log('updateSelectedeStar');
        console.log('this.state=', this.state);
        const { selectedStar } = this.props;
        console.log('selectedStar=', selectedStar)
        console.log(selectedStar.ra, selectedStar.dec, selectedStar.name);
        if (this.state.aladinInstance && selectedStar) {
            console.log('AHAAA');

            const sources = this.state.catalog.sources;
            console.log('sources=', sources);
            //const selectedSource = sources.find(source => source.name === selectedStar.name);
            var selectedSource = sources.find(source => source.data && source.data.name === selectedStar.name);
            // selectedSource = sources[0]
            console.log('selectedSource=', selectedSource);
            if (this.state.selectedStar) {
                this.state.selectedStar.deselect();
                this.setState({ selectedStar: null })
            }
            if (selectedSource) {
                selectedSource.select();
                this.setState({ selectedStar: selectedSource });
            }
            console.log('AHAAA AHAAA');
        }
    }

    
    handleFieldClick(event) {
        console.log('Field clicked at RA:', event.ra, 'DEC:', event.dec);
        const { setProps } = this.props;

        if (setProps) {
            setProps({ clickedCoordinates: { ra: event.ra, dec: event.dec } });
        }
    }
    
    handleDoubleClick(event) {
        console.log('Double click detected at RA:', event.ra, 'DEC:', event.dec);
        const { setProps } = this.props;

        if (setProps) {
            setProps({ doubleClickedCoordinates: { ra: event.ra, dec: event.dec } });
        }
    }

    
    handleStarClick(object) {
        // console.log('handleStarClick, object=', object)
        console.log('handleStarClick: ra, dec, data=', object.ra, object.dec, object.data);
        // console.log('this.state=', this.state)
        const { setProps } = this.props;
        console.log('setProps=', setProps)
        if (object && object.ra && object.dec && object.data.name) {
            const ra = object.ra;
            const dec = object.dec;
            const name = object.data.name
            if (setProps) {
                setProps({ selectedStar: { ra, dec, name } });
            }
        }
    }

    
    render() {
        const { width, height } = this.props;
        return (
            <div 
                id='aladin-lite-div' 
                style={{ width: `${width}px`, height: `${height}px` }}
            ></div>
        );
    }
}


AladinLiteReactComponent.defaultProps = {
    width: 500,
    height: 500,
    target: '03 47 00.00 +24 07 00.0',
    stars: [],
    fov: 2,
    selectedStar: null,
    clickedCoordinates: null,
    doubleClickedCoordinates: null,
    // onStarClick: () => {}
};

AladinLiteReactComponent.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks.
     */
    id: PropTypes.string,

    /**
     * Aladin window width
     */
    width: PropTypes.number,

    /**
     * Aladin window height
     */
    height: PropTypes.number,
    
    /**
     * The target to display.
     */
    target: PropTypes.string,

    /**
     * The FOV of the display.
     */
    fov: PropTypes.number,
    
    /**
     * list of Marked objects.
     */
    stars: PropTypes.arrayOf(PropTypes.shape({
        ra: PropTypes.number.isRequired,
        dec: PropTypes.number.isRequired,
        name: PropTypes.string
    })),
    
    selectedStar: PropTypes.shape({
        ra: PropTypes.number,
        dec: PropTypes.number,
        name: PropTypes.string,
    }),
    
    clickedCoordinates: PropTypes.shape({
        ra: PropTypes.number.isRequired,
        dec: PropTypes.number.isRequired,
    }),  // Для координат по клику
    
    doubleClickedCoordinates: PropTypes.shape({
        ra: PropTypes.number.isRequired,
        dec: PropTypes.number.isRequired,
    }),  // Для координат по двойному клику
    
    setProps: PropTypes.func
    
    // onStarClick: PropTypes.func
};

export default AladinLiteReactComponent;
